function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getScopeByAADResource } from './scopes';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
import AuthClient from './client';
import { pick } from 'lodash-es';
export const fetchAccessTokens = ({ resources })=>_async_to_generator(function*() {
        const scopesByResource = getScopeByAADResource();
        const filteredScopesByResource = pick(scopesByResource, resources);
        const filteredResources = Object.keys(filteredScopesByResource);
        const results = yield Promise.allSettled(filteredResources.map((resource)=>{
            return AuthClient.getInstance().acquireTokenSilent({
                scopes: [
                    filteredScopesByResource[`${resource}`]
                ],
                forceRefresh: true
            });
        }));
        return results.reduce((acc, result, index)=>{
            const resource = filteredResources[`${index}`];
            if (result.status === 'rejected') {
                logger.error(JSON.stringify({
                    resource,
                    error: result.reason
                }), {
                    action: Constants.Telemetry.Action.Login,
                    actionModifier: Constants.Telemetry.ActionModifier.AccessTokenSilentFetchingError,
                    error: result.reason
                });
            } else {
                logger.info(JSON.stringify({
                    resource,
                    fromCache: result.value.fromCache
                }), {
                    action: Constants.Telemetry.Action.Login,
                    actionModifier: Constants.Telemetry.ActionModifier.AccessTokenSilentFetchingSuccess
                });
            }
            return _object_spread_props(_object_spread({}, acc), {
                [`${resource}`]: result.status === 'fulfilled' ? result.value.accessToken : ''
            });
        }, {});
    })();
